import React from 'react'
import t from 'prop-types'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const Form = props => {
  let component = (
    <form
      method={props.method}
      className={props.className}
      onSubmit={props.onSubmit}
      style={props.style}
    >
      {props.children}
    </form>
  )

  if (false !== props.useCaptcha) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}>
        {component}
      </GoogleReCaptchaProvider>
    )
  }

  return component
}

Form.propTypes = {
  method: t.string,
  className: t.string,
  onSubmit: t.func,
  style: t.string,
  useCaptcha: t.bool,
}

Form.defaultProps = {
  useCaptcha: true,
}

export default Form
